<div class="div-mask-white">
  <div class="p-2 position-relative bg-white col-lg-6 col-12 modal-delete-template">
    <button (click)="hiddenModalLogout()" mat-icon-button class="btn-close-modal">
      <mat-icon aria-label="Example icon-button with a heart icon">close</mat-icon>
    </button>

    <div class="row mx-auto w-70">
      <div class="row mx-auto w-65 mt-4 d-block">
        <div class="col d-inline position-relative div-img-alert">
          <img alt="g-modal-image" src="./assets/icons/ic_alert.svg" />
        </div>
        <p class="col d-inline fw-bold fs-5">¿Quiere cerrar sesión?</p>
      </div>
    </div>

    <div class="row mx-auto w-65 ms-3 mt-4">
      <p>Al cerrar sesión, cualquier elemento no guardado o compra sin completar será cancelada.</p>
    </div>

    <div class="row mt-2 mb-2 me-4 ms-4">
      <div class="col d-flex justify-content-end div-buttons">
        <button (click)="hiddenModalLogout()" class="me-3 button-cancel" mat-stroked-button color="accent" disableRipple="true">Cancelar</button>
        <button (click)="hiddenModalLogoutAndCloseSession()" routerLink="/authentication/login" mat-flat-button color="accent" disableRipple="true">Cerrar sesión</button>
      </div>
    </div>
  </div>
</div>
